export const fr = {
  title: `Psychosocial`,
  p1: `Vivre avec l’épilepsie peut affecter la santé psychologique et le bien-être de ceux qui en sont atteints. En effet, les personnes épileptiques sont plus susceptibles d’expérimenter de la dépression et de l’anxiété et dans certains cas des conduites suicidaires. Il est à noter que les difficultés peuvent être dues à la maladie elle-même et/ou aux effets secondaires des médicament. Les personnes atteintes d’épilepsie sont deux fois plus à risque que les personnes dans la population générale d’avoir un trouble de l’humeur (17% vs 7%).`,
  p2: `De plus, les adultes vivant avec l’épilepsie peuvent ressentir de la stigmatisation, un sentiment de gêne, le sentiment d’être à l’écart ou qu’on les évite. Afin de minimiser les impacts sur sa santé psychologique, il est recommandé d’avoir un cercle social sur lequel vous pouvez compter et qui sont bien ne pas hésiter à demander de l’aide ou du soutien lorsque ça ne va pas.`,
  p3: {
    title: `Trucs pratiques pour améliorer mon quotidien et prévenir les crises :`,
    bullets: [
      `Prendre ma médication de façon assidue`,
      `Boire assez d’eau`,
      `Manger sainement et de façon équilibrée`,
      `Limiter ma consommation d’alcool et de drogue`,
      `Prendre des douches plutôt que des bains`,
      `Éviter de verrouiller la porte de la salle de bain`,
      `Être accompagné pour les activités présentant un risque de chute ou qui sont dangereuses (ex. baignade)`
    ]
  },
  p4: {
    before: `Pour obtenir de l’informations sur les centres près de chez vous qui offrent des services de soutien psychologique, composez le 811 ou rendez-vous sur `,
    after: `.`,
    link: `https://www.ordrepsy.qc.ca`
  }
};
